/**
 * Contagem local de um CSV de contatos.
 *
 * Roda inteiro no navegador (FileReader): o arquivo NUNCA sobe na previa e,
 * quando o backend existir, a contagem previa continua sendo local -- e o que
 * permite dizer "N contatos, M invalidos" antes de qualquer upload.
 *
 * Regra de validade deliberadamente simples: a linha vale se algum campo tem
 * de 10 a 13 digitos (DDD + numero, com ou sem 55). Normalizar em E.164 de
 * verdade e trabalho do motor (src/domain/phone.ts), nao do painel.
 */

export interface ContagemCsv {
  readonly total: number;
  readonly invalidos: number;
}

const SEPARADORES = /[;,\t|]/;
const MINIMO_DIGITOS = 10;
const MAXIMO_DIGITOS = 13;

function campoTemTelefone(campo: string): boolean {
  const digitos = campo.replace(/\D/g, '');
  return digitos.length >= MINIMO_DIGITOS && digitos.length <= MAXIMO_DIGITOS;
}

function linhaTemTelefone(linha: string): boolean {
  return linha.split(SEPARADORES).some(campoTemTelefone);
}

export function contarContatosCsv(texto: string): ContagemCsv {
  const linhas = texto
    .split(/\r?\n/)
    .map((l) => l.trim())
    .filter((l) => l !== '');
  const primeira = linhas[0];
  // A primeira linha e cabecalho quando nao tem nenhum campo com cara de telefone.
  const corpo = primeira !== undefined && linhas.length > 1 && !linhaTemTelefone(primeira) ? linhas.slice(1) : linhas;
  let invalidos = 0;
  for (const linha of corpo) {
    if (!linhaTemTelefone(linha)) {
      invalidos += 1;
    }
  }
  return { total: corpo.length, invalidos };
}

/** Le o arquivo como texto e conta. Rejeita quando o navegador nao consegue ler. */
export function contarArquivoCsv(arquivo: File): Promise<ContagemCsv> {
  return new Promise((resolve, reject) => {
    const leitor = new FileReader();
    leitor.onload = () => {
      resolve(contarContatosCsv(typeof leitor.result === 'string' ? leitor.result : ''));
    };
    leitor.onerror = () => {
      reject(new Error('Não foi possível ler o arquivo.'));
    };
    leitor.readAsText(arquivo);
  });
}
